export default "__VITE_ASSET__CmJFonLU__"